/** @format */

export const normalizeInternalLink = (link: string, urlExtension = true) => {
  const normalizedLink = link.startsWith('/') ? link.slice(1) : link;
  const arr = normalizedLink.split('/').filter(Boolean);
  const href = urlExtension ? ['business', ...arr].join('/') : arr.join('/');
  return href ? `/${href}/` : '';
};
